{
  "companies": {
    "headTitle": "Companies",
    "title": "Companies",
    "sections": {
      "summary": "Summary",
      "projects": "Projects",
      "errors": "Errors",
      "accounts": "Accounts",
      "entries": "Entries",
      "invoices": "Invoices",
      "requisites": "Requisites",
      "terms": "Plans",
      "tariffs": "Tariffs",
      "limits": "Limits",
      "members": "People",
      "models": "Models",
      "addMember": "Add employee",
      "membersEmpty": "No people yet.",
      "invitationsTitle": "Invitations",
      "invitationsEmpty": "No active invitations.",
      "inactive": "inactive",
      "deactivate": "Deactivate",
      "activate": "Activate",
      "catalog": "All projects"
    },
    "create": "Create",
    "searchPlaceholder": "Name or slug…",
    "empty": "No companies yet. Press “Create”.",
    "filterEmpty": "No matches.",
    "columns": {
      "name": "Company",
      "slug": "Slug",
      "owner": "Owner",
      "members": "Users",
      "projects": "Projects",
      "balance": "Available",
      "enforcement": "Billing",
      "models": "Models",
      "createdAt": "Created"
    },
    "internalBadge": "System",
    "internalHint": "Platform system company: billing is not tracked.",
    "noOwner": "No owner",
    "enforcementBadge": {
      "off": "Off",
      "shadow": "Shadow",
      "enforced": "On"
    },
    "filters": {
      "enforcement": "Billing mode",
      "enforcementReset": "Clear filter",
      "modelsRestricted": "Restricted models only",
      "showArchived": "Show archived"
    },
    "totals": "{{companies}} · {{projects}} · {{members}}",
    "totalsWithInternal": "{{totals}} · {{internal}} system",
    "companiesCount_one": "{{formatted}} company",
    "companiesCount_other": "{{formatted}} companies",
    "projectsCount_one": "{{formatted}} project",
    "projectsCount_other": "{{formatted}} projects",
    "membersCount_one": "{{formatted}} user",
    "membersCount_other": "{{formatted}} users",
    "modelsAll": "All",
    "modelsOf": "{{count}} of {{total}}",
    "membersLinkTitle": "Show company users",
    "projectsLinkTitle": "Show company projects",
    "modelsKind_image": "Images",
    "modelsKind_video": "Video",
    "modelsKind_audio": "Audio",
    "modelsKind_text": "Text",
    "modelsKind_transcription": "Transcription",
    "modelsKind_post_production": "Post-production",
    "modelsKind_lipsync": "Lipsync",
    "peek": {
      "close": "Close",
      "moreActions": "Company actions",
      "open": "Open",
      "openHint": "Open company page",
      "rename": "Rename",
      "copyLink": "Copy card link",
      "linkCopied": "Link copied",
      "copyFailed": "Could not copy the link",
      "createdInline": "created {{date}}",
      "archivedNotice": "Archived since {{date}}",
      "archivedBy": "Archived by {{name}}",
      "archive": "Archive company",
      "unarchive": "Restore from archive",
      "billingSection": "Billing",
      "billingDashboardLink": "Dashboard",
      "billingJournalLink": "Journal",
      "billingPriceListLink": "Company price list",
      "tileAvailable": "Available",
      "tileHeld": "on hold {{amount}}",
      "tileSpend": "Spend · 30d",
      "tileGenerations": "Generations · 30d",
      "tileAverage": "≈ {{amount}} per generation",
      "rowMode": "Mode",
      "modeSince": "since {{date}}",
      "rowPlan": "Plan",
      "planNone": "not assigned",
      "planOpen": "Open plan",
      "planCancel": "Cancel plan",
      "planCancelConfirm": "Cancel plan {{code}} for this company? The discount will stop applying.",
      "rowTariffs": "Tariffs",
      "overridesCount_one": "{{count}} override",
      "overridesCount_other": "{{count}} overrides",
      "overridesRest": "the rest follows GPL",
      "overridesNone": "platform GPL only",
      "rowAccounts": "Accounts",
      "accountsCount_one": "{{count}} account",
      "accountsCount_other": "{{count}} accounts",
      "accountsNone": "no accounts",
      "accountsColumn": "Account",
      "accountsTotal": "Total",
      "accessSection": "Access",
      "rowModels": "Models",
      "agentModel": "Agent model",
      "agentModelInherit": "Platform default ({{name}})",
      "modelsAll": "All models",
      "modelsAllHint": "No restrictions: everything available on the platform can be used.",
      "modelsRestricted": "Selected only",
      "modelsRestrictedHint": "Only the checked models can be used; the rest stay visible but unavailable.",
      "modelsTotal": "{{total}} in total",
      "modelsPick": "Choose models…",
      "teamSection": "Team",
      "owners": "Owners",
      "assignOwner": "Assign owner",
      "membersWord_one": "user",
      "membersWord_other": "users",
      "projectsWord_one": "project",
      "projectsWord_other": "projects"
    },
    "page": {
      "headTitle": "{{name}} · company",
      "copyLink": "Copy page link",
      "linkCopied": "Link copied",
      "planLinkTitle": "Plans and assignments",
      "rowOffer": "Offer",
      "offerLinkTitle": "Open the offer text",
      "offerAccepted": "accepted {{date}} · version {{version}}",
      "offerMissing": "no acceptance recorded",
      "offerNoOwner": "no owner — nobody to record the acceptance for",
      "moneySection": "Finance",
      "activitySection": "Activity over the year",
      "tileSpend": "Spend for period",
      "tileGenerations": "Generations for period",
      "running": "{{count}} running",
      "accountArchived": "archived",
      "accountsEmpty": "No accounts. Without a default account {{shadow}} and {{enforced}} modes are unavailable.",
      "tileMembers": "Members",
      "tileProjects": "Projects",
      "projectsArchived": "{{count}} archived",
      "tileGenerationsTotal": "Generations",
      "generationsAllTime": "all time",
      "tileModels": "Models",
      "modelsAllSub": "no restrictions",
      "modelsRestrictedSub": "selected only",
      "tileOwners": "Owners",
      "ownersMore": "{{name}} +{{count}}",
      "membersDeactivated": "deactivated: {{count}}",
      "membersInvited": "invitations: {{count}}",
      "membersAllActive": "all active",
      "accountActions": "Account actions",
      "deposit": "Deposit",
      "adjust": "Adjust",
      "setDefault": "Make default",
      "archiveAccount": "Archive account",
      "transfer": "Transfer between accounts",
      "accountSettings": "Price list and overdraft",
      "multiCurrencyEnable": "Enable foreign-currency accounts",
      "multiCurrencyDisable": "Disable foreign-currency accounts",
      "multiCurrencyOn": "Foreign-currency accounts are on: USD/EUR accounts are charged only by projects bound to them.",
      "archivedMoneyHint": "The company is archived: deposits, transfers and invoicing are unavailable until it is restored.",
      "invoicesSection": "Invoices",
      "invoicesAll": "All invoices",
      "issueInvoice": "Issue invoice",
      "invoicesEmpty": "No invoices yet.",
      "invoiceTotalsIssued": "issued: {{count}} for {{amount}}",
      "invoiceTotalsPaid": "paid: {{amount}}",
      "invoiceTotalsOutstanding": "outstanding: {{amount}}",
      "invoiceTotalsExpired": "overdue: {{count}}",
      "pendingOrder": "payment order pending",
      "invoiceActions": "Invoice actions",
      "movementsSection": "Money movements",
      "movementsEmpty": "No money movements in this period.",
      "entryTotalCount": "entries: {{count}}",
      "showTechnical": "Show technical",
      "holdsTitle": "Open holds",
      "holdsEmpty": "No open holds.",
      "holdOverdue": "overdue",
      "holdColumns": {
        "created": "Created",
        "amount": "Held",
        "captured": "Captured",
        "remaining": "Remaining",
        "expires": "Expires"
      },
      "termsSection": "Plans and deposits",
      "plansAll": "All plans",
      "plansEmpty": "No plans assigned.",
      "depositsSummary": "Deposits: {{count}} · paid {{paid}} · credited {{credited}} · refunded {{refunded}}",
      "planDiscount": "{{percent}}% discount",
      "planTermsColumn": "Terms",
      "requisitesSection": "Payer details",
      "requisitesEmpty": "The company has not filled in its payer details.",
      "requisitesDirector": "Director",
      "requisitesContacts": "Contacts",
      "noBankAccounts": "No bank accounts.",
      "onlinePaymentsSection": "Online payments",
      "paymentMethod": "Method",
      "topProjects": "Projects by spend",
      "projectsSpending": "with spend: {{count}}",
      "projectArchived": "archived",
      "boundTitle": "Projects on separate accounts",
      "boundHint": "Other projects are charged to the default account.",
      "boundAccountArchived": "account archived — charged to default",
      "boundBlocked": "no funds — generations blocked",
      "errorsSection": "Frequent errors",
      "errorsAll": "All errors",
      "errorsEmpty": "No failed generations in this period.",
      "errorNoText": "No error text",
      "errorLast": "last: {{when}}",
      "sharingSection": "Project sharing",
      "sharingEmpty": "The company neither shares projects nor receives shared ones.",
      "sharingGiven": "Shared out",
      "sharingGivenHint": "Guests' generations in these projects count toward this company's spend. Who granted access is not stored.",
      "sharingReceived": "Shared with the company",
      "sharingNone": "None.",
      "sharingRevokeGiven": "Revoke {{company}}'s access to {{project}}?",
      "sharingRevokeReceived": "Revoke this company's access to {{project}} owned by {{company}}?",
      "signals": {
        "no_owner": "No owner",
        "no_default_account": "No default account",
        "no_money": "Negative balance: {{amount}}",
        "no_money_zero": "Zero balance",
        "runway": "Enough for {{days}} d.",
        "failures": "Failures in the last day: {{count}}",
        "stuck_queue": "Queue is stuck: {{count}} running, oldest started {{since}}",
        "overdue_holds": "Overdue holds: {{count}} for {{amount}}",
        "unsettled": "Unsettled charges: {{count}}",
        "unrated": "Without a tariff: {{count}}",
        "expired_invoices": "Overdue invoices: {{count}} for {{amount}}",
        "expired_invitations": "Expired invitations: {{count}}",
        "requisites_missing": "No payer details",
        "requisites_state": "Counterparty status: {{state}}",
        "checklist": "Checklist · {{passed}} of {{total}}",
        "checklistTitle": "Company checklist",
        "checklistPassed": "{{passed}} of {{total}} fine",
        "groupAttention": "Needs attention",
        "groupInfo": "For your information",
        "groupOk": "All good",
        "okTitles": {
          "no_owner": "Owner assigned",
          "no_default_account": "Default account exists",
          "no_money": "Balance is positive",
          "runway": "Funds last about {{days}} d.",
          "failures": "No failed generations in the last day",
          "stuck_queue": "Queue isn't stuck",
          "overdue_holds": "No overdue holds",
          "unsettled": "All charges settled",
          "unrated": "Every generation has a tariff",
          "expired_invoices": "No overdue invoices",
          "expired_invitations": "No expired invitations",
          "requisites": "Payer details are in order"
        },
        "hints": {
          "no_owner": "Without an owner nobody manages the team, billing and payments, and the offer acceptance has no one to belong to.",
          "no_default_account": "Projects without their own budget are charged to the default account. Without it {{shadow}} and {{enforced}} modes are unavailable. It is usually created automatically on the first generation, payment or promo code.",
          "no_money": "Available across active accounts. In {{enforced}} mode generations stop at zero; in {{shadow}} mode they go negative.",
          "runway": "Forecast from the average daily spend since the first charge, up to a year. Warns when a week or less is left.",
          "failures": "Failed generations of every job kind in the last 24 hours — monitoring opens them together with the error texts.",
          "stuck_queue": "Generations queued or running for over two hours: most likely the provider didn't respond or a worker died.",
          "overdue_holds": "A hold reserves money for a generation and closes with a charge or a release. An overdue one keeps the client's money past its deadline.",
          "unsettled": "Successful paid generations after billing was turned on with no account charge: the company balance is overstated.",
          "unrated": "Successful generations with no matching rate — they ran for free. The model needs a rate in the price list.",
          "expired_invoices": "Issued invoices past their due date that aren't fully paid.",
          "expired_invitations": "Invitations nobody accepted in time. The owner can resend or revoke them in the company's Members section.",
          "requisites": "An invoice needs a payer profile and an active bank account. A registry status other than active is a reason to check the company before invoicing."
        },
        "actions": {
          "no_owner": "Assign an owner",
          "no_default_account": "Go to accounts",
          "no_money": "Go to accounts",
          "runway": "Go to accounts",
          "failures": "Open failures in monitoring",
          "stuck_queue": "Open running in monitoring",
          "overdue_holds": "Go to holds",
          "unsettled": "Open in the usage journal",
          "unrated": "Open in the usage journal",
          "expired_invoices": "Go to invoices",
          "expired_invitations": "Go to the Members tile",
          "requisites": "Go to payer details"
        },
        "actionCreateAccount": "Create an account"
      }
    },
    "createDialog": {
      "title": "New company",
      "submit": "Create",
      "cancel": "Cancel",
      "name": "Name",
      "namePlaceholder": "Acme Studio",
      "owner": "Owner",
      "ownerHint": "Optional — the owner can be assigned later."
    },
    "renameDialog": {
      "title": "Rename company",
      "submit": "Save",
      "cancel": "Cancel",
      "name": "Name"
    },
    "ownerDialog": {
      "title": "Assign owner",
      "submit": "Assign",
      "cancel": "Cancel",
      "owner": "Owner",
      "hint": "The user becomes the company owner with full rights in it."
    },
    "modelsDialog": {
      "title": "Available models",
      "search": "Search by name or key…",
      "all": "All models",
      "restricted": "Selected only",
      "hint": "Without a restriction the company sees every model. With one, the rest stay listed but cannot be picked.",
      "selected": "{{count}} of {{total}} selected",
      "selectAll": "Select all",
      "clearAll": "Clear all",
      "save": "Save",
      "cancel": "Cancel",
      "emptyCatalog": "The model catalog is empty.",
      "nothingFound": "No matches.",
      "groupCount": "{{selected}} / {{total}}",
      "expandFamily": "Show versions",
      "collapseFamily": "Hide versions"
    },
    "archivedBadge": "Archived",
    "archiveDialog": {
      "title": "Archive the company?",
      "body": "“{{name}}” disappears from lists and the company switcher, and nobody but a super-admin can enter it. Generations and any account operations are blocked, and its projects leave the catalogs.",
      "reversible": "The company can be restored at any time — data, money and invitations are kept.",
      "money": "Accounts hold {{balance}}, {{held}} held.",
      "running": "Generations running now: {{count}}. They will finish, new ones will not start.",
      "confirm": "Archive",
      "cancel": "Cancel"
    }
  },
  "users": {
    "headTitle": "Users",
    "title": "Users",
    "inviteButton": "Invite",
    "searchPlaceholder": "Name or email…",
    "searching": "Searching…",
    "filterByCompany": "Filter by companies",
    "companyFilterSearch": "Search companies…",
    "clearCompanyFilter": "Reset",
    "selectedCompaniesGroup": "Selected",
    "allCompaniesGroup": "All companies · {{count}}",
    "removeCompanyChip": "Remove “{{company}}” from filter",
    "onlySuperAdmins": "Super-admins only",
    "columns": {
      "name": "Name",
      "email": "Email",
      "companies": "Companies",
      "lastSeen": "Last seen",
      "active": "Active"
    },
    "superAdminBadge": "Super-admin",
    "moreCompanies": "+{{count}}",
    "totals": "{{users}} · {{companies}} · {{superAdmins}}",
    "usersCount_one": "{{formatted}} user",
    "usersCount_other": "{{formatted}} users",
    "companiesCount_one": "{{formatted}} company",
    "companiesCount_other": "{{formatted}} companies",
    "superAdminsCount_one": "{{formatted}} super-admin",
    "superAdminsCount_other": "{{formatted}} super-admins",
    "found": "Found {{found}} of {{total}}",
    "foundInCompany": "{{found}} · company “{{company}}”",
    "foundInCompanies": "{{found}} · {{companies}}",
    "range": "{{from}}–{{to}} of {{total}}",
    "prevPage": "Previous page",
    "nextPage": "Next page",
    "empty": "No users yet.",
    "filterEmpty": "No matches.",
    "open": "Open",
    "openHint": "Open user page",
    "editName": "Edit name",
    "copyLink": "Copy card link",
    "linkCopied": "Link copied",
    "copyFailed": "Could not copy",
    "meta": "On the platform since {{created}} · last seen {{lastSeen}}",
    "metaNeverSeen": "On the platform since {{created}} · never signed in",
    "emailConfirmed": "email confirmed",
    "emailNotConfirmed": "email not confirmed",
    "membershipsSection": "Companies and roles · {{count}}",
    "noMemberships": "Not a member of any company.",
    "allProjects": "All projects",
    "projectsPrefix": "Projects:",
    "noProjects": "No projects",
    "deactivatedInCompany": "Deactivated in this company",
    "roleAria": "Role in “{{company}}”",
    "lockLastOwner": "Sole owner — assign another owner first",
    "lockSelf": "You cannot change your own role",
    "lockDeactivated": "Deactivated in this company",
    "remove": "Remove",
    "addToCompany": "Add to company…",
    "companySearch": "Search companies…",
    "companySearchEmpty": "No matches",
    "addRoleAria": "Company role",
    "add": "Add",
    "confirmPromoteTitle": "Make {{name}} an owner of “{{company}}”?",
    "confirmPromoteMessage": "Owners see all projects, members and billing of the company.",
    "confirmPromote": "Make owner",
    "confirmDemoteTitle": "Remove the owner role from {{name}} in “{{company}}”?",
    "confirmDemoteMessage": "They become a member and stay only on projects where they have a role.",
    "confirmDemote": "Remove owner role",
    "confirmRemoveTitle": "Remove {{name}} from “{{company}}”?",
    "confirmRemoveAssignments": "Project assignments ({{count}}) will be removed.",
    "confirmRemoveMessage": "Work history stays; you can invite them again at any time.",
    "confirmRemove": "Remove from company",
    "removeMembershipTitle": "Remove from company",
    "confirmRemoveMembership": "Remove {{email}} from “{{company}}”?",
    "superAdminSection": "Super-admin",
    "superAdmin": "Platform super-admin",
    "superAdminHint": "All companies, billing and platform settings. Granting and revoking require your password.",
    "cannotRevokeSelf": "You cannot revoke your own rights — ask another super-admin.",
    "confirmGrantTitle": "Grant super-admin rights to {{name}}?",
    "confirmGrantMessage_one": "A super-admin sees the {{formatted}} company, its billing and platform settings, and can open it as its owner. Enter your password to confirm.",
    "confirmGrantMessage_other": "A super-admin sees all {{formatted}} companies, their billing and platform settings, and can open any company as its owner. Enter your password to confirm.",
    "confirmRevokeTitle": "Revoke super-admin rights from {{name}}?",
    "confirmRevokeMessage": "They lose access to platform sections and to companies they don't belong to. Enter your password to confirm.",
    "grant": "Grant rights",
    "revoke": "Revoke rights",
    "confirmPasswordLabel": "Your password",
    "passwordSection": "Password",
    "passwordHint": "We'll email the user a link to change their password. The current password keeps working until they set a new one; after that all sessions end.",
    "sendResetLink": "Send reset link",
    "sendResetLinkAgain": "Send again",
    "sendResetLinkSelf": "Change your own password in your profile",
    "resetLinkSentAt": "Link sent {{date}}",
    "confirmSendResetTitle": "Send a password reset link?",
    "confirmSendResetMessage": "The link goes to {{email}} and is valid for 30 minutes. The current password keeps working until the user sets a new one; after that all their sessions end.",
    "confirmSendReset": "Send link",
    "deactivate": "Deactivate",
    "activate": "Restore",
    "lockOwnerDeactivate": "An owner cannot be deactivated — change the role first",
    "lockSelfDeactivate": "You cannot deactivate yourself",
    "deactivateDialogTitle": "Deactivate {{name}}",
    "deactivateDialogHint": "Access to the checked companies is closed right away. The person stays on their teams and can be restored at any time.",
    "deactivateSubmit": "Deactivate ({{count}})",
    "deactivateNone": "No companies where this user can be deactivated",
    "page": {
      "headTitle": "{{name}} · user",
      "moreActions": "User actions",
      "copyLink": "Copy page link",
      "signOutEverywhere": "Sign out everywhere",
      "signOutSelf": "End your own sessions in your profile, under Security",
      "confirmSignOutTitle": "End all sessions for {{name}}?",
      "confirmSignOutMessage": "They will be signed out in every browser and their Claude Desktop sessions will be revoked. MCP keys keep working — revoke them separately.",
      "grantSuperAdmin": "Grant superadmin rights",
      "revokeSuperAdmin": "Revoke superadmin rights",
      "onPlatformSince": "on the platform since {{date}}",
      "lastSeen": "last sign-in {{when}}",
      "neverSeen": "never signed in",
      "pendingEmail": "email change to {{email}} not confirmed",
      "resetLinkSent": "password reset link sent {{date}}",
      "membershipActions": "Membership actions",
      "columns": {
        "company": "Company",
        "role": "Role",
        "joined": "Member since",
        "projects": "Projects",
        "spend": "Spend",
        "key": "Key",
        "app": "App",
        "created": "Created",
        "started": "Started",
        "lastUsed": "Last used",
        "expires": "Expires",
        "invitedBy": "Invited by",
        "sent": "Sent",
        "validUntil": "Valid until"
      },
      "projectsEmpty": "No project assignments and no project generations in the period.",
      "apiTokensTitle": "MCP keys",
      "apiTokensEmpty": "No keys.",
      "oauthSessionsTitle": "OAuth sessions",
      "oauthSessionsEmpty": "No sessions.",
      "confirmRevokeTokenTitle": "Revoke key “{{name}}”?",
      "confirmRevokeTokenMessage": "Clients using this key will stop acting as {{person}}.",
      "confirmRevokeSessionTitle": "Revoke the session for “{{name}}”?",
      "confirmRevokeSessionMessage": "The app will need to sign in again as {{person}}.",
      "invitationsTitle": "Incoming invitations · {{count}}",
      "invitationExpired": "Expired"
    }
  },
  "projectCatalog": {
    "headTitle": "Project catalog",
    "title": "Project catalog",
    "empty": "No projects found",
    "filters": {
      "searchPlaceholder": "Search by name, slug, company…",
      "allCompanies": "All companies",
      "companySearch": "Search companies…",
      "companyEmpty": "No matches",
      "allTypes": "All types",
      "lifecycleAll": "All",
      "lifecycleActive": "Active",
      "lifecycleArchived": "Archived",
      "showArchivedCompanies": "Projects of archived companies"
    },
    "columns": {
      "id": "ID",
      "name": "Name",
      "company": "Company",
      "projectType": "Type",
      "status": "Status",
      "workflowStage": "Stage",
      "createdBy": "Created by",
      "createdAt": "Created",
      "updatedAt": "Updated",
      "archivedAt": "Archived"
    },
    "archivedBadge": "Archived",
    "prevPage": "Previous",
    "nextPage": "Next",
    "pageOf": "Page {{page}} / {{pages}}",
    "range": "{{from}}–{{to}} of {{total}}",
    "perPage": "{{count}} / page"
  },
  "userPicker": {
    "placeholder": "Name or email…",
    "searching": "Searching…",
    "failed": "Could not load the list",
    "retry": "Retry",
    "nothingFound": "Nobody found",
    "truncated": "Showing the first {{count}} — refine the query",
    "clear": "Clear",
    "empty": "Not selected"
  }
}
